 <template>
  <div class="mxp" id="shareWarp" ref="shareWarp">
  	<img :src="primary_image" class="primary_image">
  	<div class="change" v-if="more_image.length && showBtn" @click="changeImg"><i></i>换一换</div>
  	<div class="buttons">
  		<div class="buttonConfirm" v-if="showBtn" @click="drawCanvas('#shareWarp')"><i></i>保存明信片</div>
  		<!-- <div class="buttonConfirm"><i></i>分享朋友</div> -->
  	</div>
  	<div class="shareImg" v-if="showShareImg">
  		<div class="shareWarp">
  			<img :src="newSrc">
      	<div class="text">请长按图片保存后分享给好友</div>
  		</div>
    </div>
    <div class="loading" v-if="showLoading">
      <img src="@/assets/ticket/loading.png">
      <div>图片生成中，请稍候</div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
export default {
  data() {
    return {
    	primary_image: '',
    	more_image: [],
    	newSrc: '',
    	showShareImg: false,
    	showLoading: false,
    	changeIndex: 0,
    	showBtn: true
    };
  },

  methods: {
    getDatas() {
    	let params = {
    		deptId: this.$route.query.museumCode,
    		formId: 1879442
    	}
    	this.$ajax(`/api/micro-backend/front/form/v2/list?fid=${this.$route.query.museumCode}&t=c9bf7d7ecc5c10ab610ead149a4e376762ff15ea5556de6e783e8340f3f51f17&limit=10`).then((res) =>{
    		if (!res.data.data.data.length) return alert('暂无明信片')
    		let data = res.data.data.data[0]
    		let target = data.formData[0].values[0]
    		this.primary_image = `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}`
    		this.more_image = data.formData[1].values.map((item)=>{
    			return `https://museum.chaoxing.com/star3/origin/${item.objectId}.${item.suffix}`
    		})
    		this.more_image.push(this.primary_image)
    	})
    },
    changeImg() {
    	this.changeIndex == this.more_image.length - 1 ? this.changeIndex = 0 : this.changeIndex ++
    	this.primary_image = this.more_image[this.changeIndex]
    },
    drawCanvas(loding) {
      this.showBtn = false
      this.showLoading = true
      setTimeout(() => {
      	this.newSrc = this.primary_image
      	this.showLoading = false
        this.showShareImg = true
        this.showBtn = true
     //  	this.$nextTick(() =>{
	  		// 	this.drawCanvasFun(loding)
	  		// })
      }, 1000)
  	},
  	async drawCanvasFun(loding) {
      // 获取想要转换的 DOM 节点
      const dom = this.$refs.shareWarp
      const box = window.getComputedStyle(dom);
      // DOM 节点计算后宽高
      const width = parseInt(box.width, 10);
      const height = parseInt(box.height, 10);
      // 获取像素比
      const scaleBy = this.DPR();
      // 创建自定义 canvas 元素
      var canvas = document.createElement('canvas');
      // 设定 canvas 元素属性宽高为 DOM 节点宽高 * 像素比
      canvas.width = width;
      canvas.height = height;
      canvas.id = 'can';
      // 设定 canvas css宽高为 DOM 节点宽高
      canvas.style.width = `${width / 100}rem`;
      canvas.style.height = `${height / 100}rem`;
      // 获取画笔
      const context = canvas.getContext('2d');
      // 将所有绘制内容放大像素比倍
      // context.scale(scaleBy, scaleBy);
      let x = width;
      let y = height;
      let that = this
      return await html2canvas(dom, {
        backgroundColor: null,
        canvas,
        useCORS: true
      }).then(function (canvas) {
        that.newSrc = that.convertCanvasToImage(canvas, x, y).src;
        that.showLoading = false
        that.showShareImg = true
        that.showBtn = true
      })
    },
    DPR() {
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
      }
      return 1;
    },
    convertCanvasToImage(canvas, x, y) {
      let image = new Image();
      image.setAttribute("crossOrigin", 'Anonymous');
      image.width = x;
      image.height = y;
      image.src = canvas.toDataURL("image/png");
      return image;
    },
  },

  created() {
  	this.getDatas()
  	let list = ['html2canvas.js']
    list.map((item) => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/3d/${item}`;
      document.body.appendChild(oScript);
    })
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.mxp{
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	.primary_image{
		width: 100%;
		height: 100%;
		z-index: -1;
		object-fit: cover;
	}
	.change{
		position: fixed;
		top: 0.5rem;
		right: 0.5rem;
		font-size: 0.45rem;
		i{
			display: inline-block;
			width: 0.4rem;
			height: 0.4rem;
			margin-right: 0.2rem;
			-webkit-mask: url('~@/assets/ticket/change.svg') 0 0/100% 100% no-repeat;
    	mask: url('~@/assets/ticket/change.svg') 0 0/100% 100% no-repeat;
    	transform: translateY(0.02rem);
		}
	}
	.buttons{
		width: 100%;
		position: fixed;
		bottom: 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.buttonConfirm{
			i{
				display: inline-block;
				width: 0.4rem;
				height: 0.4rem;
				margin-right: 0.2rem;
				margin-top: 0.1rem;
				-webkit-mask: url('~@/assets/ticket/downLoad.svg') 0 0/100% 100% no-repeat;
      	mask: url('~@/assets/ticket/downLoad.svg') 0 0/100% 100% no-repeat;
      	background: #fff;
      	transform: translateY(0.03rem);
			}
			&:nth-child(2) {
				i{
					transform: translateY(0.04rem) translateX(0.02rem);
					width: 0.4rem;
					height: 0.4rem;
					-webkit-mask: url('~@/assets/ticket/share_icon.svg') 0 0/100% 100% no-repeat;
      		mask: url('~@/assets/ticket/share_icon.svg') 0 0/100% 100% no-repeat;
				}
			}
		}
	}
	.loading{
		text-align: center;
		color: #fff;
		font-size: .5rem;
		line-height: 1rem;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background-color: #000000b3;
	}
	.loading img{
		height: 0.7rem;
		width: 0.7rem;
		margin: auto;
		margin-top: 50%;
	}
	.shareImg{
		position: fixed;
		top: 0;
		left: 0;
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		padding: 5%;
		// min-height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #000000b3;
		.shareWarp{
			// position: absolute;
			// margin-top: -50%;
			// top: 50%;
			width: 100%;
			height: calc(100% - 1.2rem);
			position: relative;
		}
	}
	.shareImg img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.shareImg .text{
		position: absolute;
		bottom: 0.2rem;
		text-align: center;
		width: 80%;
		left: 10%;
		color: #fff;
		padding: 0.2rem 0;
    border: 1px solid #fff;
    border-radius: 075rem;
    font-weight: 500;
    font-size: 0.4rem;
    z-index: 22;
	}
}
</style>
 